import { FilterAlt } from '@mui/icons-material';
import { Button, MenuItem, Stack, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { Filter } from './types';

interface Props<T> {
  config: Filter<T>[];
  filters: Filter<T>[];
  onFilter: (filters: Filter<T>[]) => void;
  onReset?: () => void;
}
export function Filters<T>({
  config,
  onFilter,
  filters,
  onReset = () => {},
}: Props<T>) {
  const [values, setValues] = useState<Filter<T>[]>(
    config.map(item => ({ ...item })),
  );

  useEffect(() => {
    setValues(v =>
      v.map(item => ({
        ...item,
        value:
          filters.find(({ field }) => field === item.field)?.value ??
          item.value,
      })),
    );
  }, [filters]);

  const onFilterChange =
    (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValues = [...values];
      newValues[index].value = event.target.value;
      setValues(newValues);
    };

  const onResetClick = () => {
    onReset();
    setValues(config.map(item => ({ ...item })));
    onFilter(config);
  };

  const onSubmit: React.FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault();
    onFilter(values);
  };

  if (config.length === 0) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <form onSubmit={onSubmit}>
      <Stack direction="row" spacing={{ xl: 2, lg: 1 }}>
        {values.map(({ field, value, label, options }, index) => (
          <TextField
            key={field.toString()}
            label={label}
            value={value}
            defaultValue={options ? '' : undefined}
            onChange={onFilterChange(index)}
            placeholder="Enter a value"
            variant="outlined"
            size="small"
            select={!!options}
            sx={{ width: 150 }}
          >
            {options?.map(({ label: optionLable, value: optionValue }) => (
              <MenuItem key={optionValue} value={optionValue}>
                {optionLable}
              </MenuItem>
            ))}
          </TextField>
        ))}
        <Stack direction="row" spacing={1}>
          <Button
            type="submit"
            variant="contained"
            size="small"
            sx={{ minWidth: 'unset' }}
          >
            <FilterAlt />
          </Button>
          <Button
            onClick={onResetClick}
            variant="outlined"
            size="small"
            sx={{ minWidth: 'unset' }}
          >
            Clear
          </Button>
        </Stack>
      </Stack>
    </form>
  );
}
